'use client';

import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useIsWindowFocused } from '@/hooks/operation/common/useIsWindowFocused';
import { userBorrowPositionsQueryOptions } from './userBorrowPositionsQuery';
interface UseBorrowPositionsTableDataParams {
  accountAddress?: string;
  /**
   * Poll interval (ms) while the window is focused. Pass `false` to opt out of
   * polling entirely — e.g. the nav badge only warms/shares this query's cache
   * and doesn't need 10s freshness, so it avoids driving an app-wide refetch
   * storm. Because this is an observer-level option (not part of the query
   * key), opting out keeps the cache shared with the Portfolio table, which
   * reinstates the 10s poll via its own observer when opened. Defaults to 10s.
   */
  refetchInterval?: number | false;
}
export const useBorrowPositionsTableData = t0 => {
  const $ = _c(18);
  const {
    accountAddress,
    refetchInterval: t1
  } = t0;
  const refetchInterval = t1 === undefined ? 10000 : t1;
  const isWindowFocused = useIsWindowFocused();
  let t2;
  if ($[0] !== accountAddress) {
    t2 = userBorrowPositionsQueryOptions(accountAddress);
    $[0] = accountAddress;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isWindowFocused ? refetchInterval : false;
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = {
      ...t2,
      refetchInterval: t3,
      placeholderData: keepPreviousData
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const {
    data,
    isLoading,
    isPaused,
    isPending,
    isPlaceholderData,
    error
  } = useQuery(t4);
  let t5;
  if ($[5] !== data?.items) {
    t5 = data?.items ?? [];
    $[5] = data?.items;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = data?.facets;
  const t7 = !isPlaceholderData && (data?.partial ?? false);
  const t8 = data?.countTotal ?? 0;
  const t9 = error ?? undefined;
  const t10 = !isLoading && !error && !data?.partial && (data?.items.length ?? 0) === 0;
  let t11;
  if ($[7] !== isLoading || $[8] !== isPaused || $[9] !== isPending || $[10] !== isPlaceholderData || $[11] !== t10 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
    t11 = {
      borrowPositions: t5,
      isPending,
      isPaused,
      facets: t6,
      partial: t7,
      countTotal: t8,
      loading: isLoading,
      isPlaceholderData,
      error: t9,
      isNotFound: t10
    };
    $[7] = isLoading;
    $[8] = isPaused;
    $[9] = isPending;
    $[10] = isPlaceholderData;
    $[11] = t10;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
};